export const AppIncompatibleNotificationDataHooks = {
  container: 'app-incompatible-notification-container',
  findSimilarAppsLink: 'app-incompatible-notification-find-similar-apps-link',
};
